var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showChart)?_c('RadialChartWrapper',{attrs:{"actionButtonHandler":_vm.navigateToMDMPage,"certificateDetails":_vm.certificateDetails,"data-test-id":"mdmRadialBarCharts","displayName":_vm.displayName,"hasError":_vm.hasError,"isLoading":_vm.isLoading,"type":_vm.radialBar}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }